import { render, staticRenderFns } from "./BuyOrderInfo.vue?vue&type=template&id=620e532a&scoped=true&"
import script from "./BuyOrderInfo.vue?vue&type=script&lang=js&"
export * from "./BuyOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e532a",
  null
  
)

export default component.exports